<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-group">
                    <label>Product</label>
                    <div class="text-danger" v-if="customerGroupPricingDelivery.productId.hasError">
                        {{customerGroupPricingDelivery.productId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="products" :selectedOption="customerGroupPricingDelivery.productId.value" :elementId="'productSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onProductSelect"
                                      :disabled="true"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Zones Pricing</label>
                    <div class="text-danger">
                        {{customerGroupPricingDelivery.zoneErrorMessage}}
                    </div>
                    <zone-pricing-for-customer-add-update-table
                            :customerZonePricing="customerGroupPricingDelivery.zonePricing"
                            :product="customerGroupPricingDelivery.selectedProduct"
                            :clearTable="clearZonePricingTable"
                            :orderTypeId="orderTypeId"
                            @zoneSelected="onZoneSelected"></zone-pricing-for-customer-add-update-table>
                </div>
                <div class="form-group">
                    <label>Effective Date</label>
                    <input type="text"
                           class="form-control"
                           :value="$filters.dateDefaultStandard(customerGroupPricingDelivery.effectiveDate.value, false)"
                           :disabled="true"/>
                </div>
                <button class="btn btn-primary" @click.prevent="onBackClick" :disabled="loading">Back</button>
            </div>
        </div>
    </div>
    
</div>
